import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { ICON_SIZE, MARGIN, defaultContext, getInitialStyle } from './feature.style';
import Icon from '../../icon/icon.component';

export class Feature extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Icon: {
          type: Icon,
        },
        Text: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  set title(value) {
    this.tag('Text').text.text = value;
  }

  get w() {
    return super.w;
  }

  set w(value) {
    super.w = value;
    const { screenSize } = this._style;
    this.tag('Text').patch({
      text: {
        wordWrapWidth: value - ICON_SIZE.WIDTH[screenSize] - MARGIN[screenSize],
      },
    });
  }
}
